import ComponentManager from '@/Management/ComponentManager';
import DetailViewViewModel from '@/ViewModels/Views/DetailViewViewModel';
import ModalDetailViewContext from '@/Components/ModalDetailView/ModalDetailViewContext';
import MessageBoxViewModel from '@/ViewModels/Controls/MessageBoxViewModel';
import RADApplication from '@/Management/RADApplication';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';

export default class ModalDetailViewViewModel extends DetailViewViewModel {

    /**
     * Das ViewModel der aufrufenden (modalen) DetailView 
     */
    protected __parent: DetailViewViewModel;

    /**
     * Der aufrufende (Modal)DetailViewContext
     */
    protected __caller: DetailViewContext;

    /**
     * ID des aktuellen Contexts
     */
    public currentContextIdentifier: string;

    private detailViewContextCounterModal: number;

    /**
     * @override
     */
    public currentContext: KnockoutComputed<ModalDetailViewContext>;

    constructor(protected params: any) {
        super(params);
        this.__parent = this.paramOrDefault(params.parent, null);
        this.__caller = this.paramOrDefault(params.caller, null);
    }

    /**
     * @override
     */
    protected initContext(): void {
        this.detailViewContextCounterModal = this.paramOrDefault(this.params.detailViewContextCounter, 0);

        const context = new ModalDetailViewContext({
            parentLocator: this.locator,
            locator: this.defineComputed(() => {
                return 'modaldv.' + this.getDetailViewContextCounter();
            }),
            detailViewContextCounter: this.getDetailViewContextCounter(),
            viewModel: this,
            caller: this.params.caller,
            pdTypeName: this.params.pdTypeName,
            pdoId: this.params.pdoId,
            contextPdoId: this.params.contextPdoId,
            contextPdTypeName: this.params.contextPdTypeName,
            contextRelationName: this.params.contextRelationName,
            contextParameters: this.params.contextParameters,
            action: 'CREATE',
            serializedFilters: this.serializedFilters
        });

        // Umfassender Kontext wird als geändert markiert
        // Hier muss auf params zugegriffen werden, da __caller noch nicht initalisiert
        this.params.caller.genericObject.isModified(true);

        this.currentContextIdentifier = context.identifier;

        this.defineSubscription(context.detailView, (detailView) => {
            if (detailView != null) {
                this.detailViewContextStack.push(context);
            }
        }, true);
    }

    /**
     * @override
     */
    public confirmCreateContext(callback: (success: boolean) => void, showDialog: boolean = true): void {
        if (!showDialog) {
            this.triggerSaveChain(callback);
            return;
        }

        const messageBoxViewModel = MessageBoxViewModel.createSaveWarningMessageBox(this.triggerSaveChain.bind(this, callback), () => { });
        RADApplication.getInstance().showMessageBox(messageBoxViewModel);
    }

    /**
     * @override 
     */
    protected getDetailViewContextCounter(): number {
        return this.detailViewContextCounterModal;
    }

    /**
     * @override
     */
    public removeCurrentContext(callback: (context: DetailViewContext) => void) {
        super.removeCurrentContext(callback);
        this.detailViewContextCounterModal--;
    }

    private triggerSaveChain(callback: (success) => void): void {
        this.currentContext().saveModalBeforeStackNavigation().then((result) => {
            if (!result) {
                return;
            }
            if (this.__parent != null) {
                // Alle Eltern werden confirmed (validiert, gespeichert)
                this.__parent.confirmCreateContext(() => {
                    // Wenn ALLE erfolgreich sind, werden die DetailViewContext von innen nach außen geschlossen
                    callback(true);
                    (this.currentContext() as any).closeCurrentContext(); // interne Methode !
                }, false);
            }
            else {
                callback(true);
            }
        });
    }

    /**
     * @override
     */
    protected disposeInternal(): void {
        // Zwischenspeichern, da nach super.dispose kein Zugriff mehr möglich ist
        // Hier muss der root genommen werden, da ein Nested-DVC niemals der CurrentContext war
        const dvc = this.__caller.getRootDetailViewContext();
        
        super.disposeInternal();
        // Wenn ein modaler Dialog geschlossen wird, wird durch die Oberklasse aktuell der currentDetailViewContext im dispose
        // auf null gesetzt. Es muss aber der aufrufende Context nun als currentDetailViewContext agieren
        RADApplication.getInstance().currentDetailViewContext(dvc);
    }
}

ComponentManager.setViewModel('ModalDetailView', ModalDetailViewViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');